<template>
  <a-modal
    title="回款记录"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="id" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input :disabled="showable" v-decorator="['id']" />
        </a-form-item>
        <a-form-item
          label="日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-date-picker
            style="width: 100%"
            :disabled="showable"
            v-decorator="[
              'recordDate',
            ]"></a-date-picker>
        </a-form-item>
        <a-form-item
          label="总金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :disabled="showable"
            placeholder="请输入"
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="['amount', {rules: [{required: true, message: '请输入总金额'}]}]" />
        </a-form-item>
        <a-form-item
          label="备注内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['remark', {rules: [{required: true, message: '请输入备注内容'}]}]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <div>
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import moment from 'moment'
export default {
  name: 'RecordAdd',
  components: {},
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      theKey: 0,
      showable: false,
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      }
    }
  },
  methods: {
    // 获取用户消息
    edit (child, type) {
      this.visible = true
      if (type === 'edit') {
        this.type = type
        this.theKey = child.key
      }
      if (type && type === 'add') {
        this.type = type
      }
      const {
        form: { setFieldsValue, resetFields }
      } = this
      if (type === 'add') {
        resetFields()
      } else if (type === 'edit') {
        const pickFiled = [
          'id',
          'recordDate',
          'amount',
          'remark'
        ]
        if (child.recordDate) {
          child.recordDate = moment(child.recordDate, 'YYYY-MM-DD')
        }
        this.$nextTick(() => {
          setFieldsValue(pick(child, pickFiled))
        })
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /**
     * @return {string}
     */
    Formatting (date) {
      if (date !== null) {
        return moment(date).format('YYYY-MM-DD')
      }
    },
    // 结束保存用户信息
    handleOk () {
      this.form.validateFields(async (err, values) => {
        values.recordDate = this.Formatting(values.recordDate)
        if (!err) {
          if (this.type === 'add') {
            this.$emit('changeData', values)
          } else if (this.type === 'edit') {
            values.key = this.theKey
            this.$emit('editData', values)
          }
          this.visible = false
        }
      })
    },
    handleCancel () {
      this.visible = false
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    }
  }
}
</script>

<style scoped>

</style>
